export default "__VITE_ASSET__CLojvbzR__"